var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", [_c("Header")], 1),
      _c("el-main", [
        _c("div", { staticClass: "login" }, [
          _c("div", [_c("LoginForm", { attrs: { title: _vm.systemName } })], 1)
        ])
      ]),
      _c("el-footer", [_c("Footer")], 1)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }